export enum Roles {
  CUSTOMERS = 1,
  PROPOSALS = 2,
  FINANCIAL_STATEMENT = 3,
  COMPANY = 4,
  DATA_ANALYSIS = 5,
  NEWSLETTER = 7,
  AGENDA = 11,
}
